import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  departments: [],
};

const departmentSlice = createSlice({
  name: "department",
  initialState,
  reducers: {
    setDepartments(state, actions) {
      state.departments = actions.payload.departments;
    },
  },
});

export const departmentActions = departmentSlice.actions;
export default departmentSlice;
